import { useContext } from "react";
import GVCompletions from "./GVCompletions";
import GVMapView from "./GVMapView";
import { PageHeader } from "../components/GraphicalViewer/PageHeader";
import { ResizablePanel } from "../components/ResizablePanel";
import { GraphicalViewerContext } from "../../contexts/GraphicalViewerContext";

export default function GVHybridView() {
    const { isDragging, setIsDragging } = useContext(GraphicalViewerContext);

    return (
        <div className={`flex w-full ${isDragging ? "cursor-col-resize" : ""}`}>
            <div className="flex-1" style={{ maxHeight: "calc(100vh - 56px)" }}>
                <GVMapView isHybridView={true} />
            </div>

            <ResizablePanel
                defaultWidth={550}
                maxWidth={800}
                minWidth={300}
                onDragStart={() => setIsDragging(true)}
                onDragEnd={() => setIsDragging(false)}
            >
                <PageHeader />
                <GVCompletions />
            </ResizablePanel>
        </div>
    );
}
